import { useState } from "react";
import { useTranslation } from "react-i18next";
import axios from "axios";

// React Icons
import { RiErrorWarningLine } from "react-icons/ri";
import { RxCross2 } from "react-icons/rx";

// Components
import Loader from "components/Loader";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import { toast } from "react-toastify";
import CryptoJS from "crypto-js";

function ReactivateModal({
  toggleReactivate,
  settoggleReactivate,
  formValues,
  getParamsEmail,
  qrCodeEmail,
  setInactiveAccount,
  inactiveAccount
}) {
  const { t } = useTranslation();
  const [isloading, setisloading] = useState(false);

  function encrypt(plainText, passwordKey) {
    const key = CryptoJS.enc.Utf8.parse(passwordKey);
    const iv = CryptoJS.enc.Hex.parse("00000000000000000000000000000000");
    const encrypted = CryptoJS.AES.encrypt(plainText, key, {
      iv: iv,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7,
    });
    const base64Encrypted = encrypted.toString();
    return encodeURIComponent(base64Encrypted);
  }

  const passwordKey = "b14ca5898a4e4133bbce2ea2315a1916";
  const encryptedText = encrypt(formValues?.email, passwordKey);
  const paramsEncrypt = encrypt(getParamsEmail, passwordKey);

  const handleModalClose =  () => {
    settoggleReactivate(false);
    setInactiveAccount(false);
  };

  const handleSubmit = async () => {
    setisloading(true);
    try {
      let URL;
      if (getParamsEmail && getParamsEmail !== "null") {
        URL = `/auth/reactivate-account-by-user?email=${paramsEncrypt}&inactiveAccount=${inactiveAccount}`;
      } else if (formValues?.email) {
        URL = `/auth/reactivate-account-by-user?email=${encryptedText}&inactiveAccount=${inactiveAccount}`;
      } else if (qrCodeEmail?.email) {
        URL = `/auth/reactivate-account-by-user?email=${qrCodeEmail?.email}&inactiveAccount=${inactiveAccount}`;
      }
      if (URL) {
        const response = await axios.post(URL);
        if (response?.data?.statusCode === 200) {
          toast.success(t(response?.data?.message));
        }
        if (response?.data?.statusCode === 404) {
          toast.error(t(response?.data?.message));
        }
        handleModalClose();
        setisloading(false);
      }
    } catch (error) {
      setisloading(false);
      console.log(error);
    }
  };

  return (
    <>
      {isloading && <Loader />}
      <Modal
        centered
        show={toggleReactivate}
        onHide={() => handleModalClose()}
        dialogClassName="modal-90w"
        aria-labelledby="example-custom-modal-styling-title"
      >
        <Modal.Body>
          <div
            style={{
              position: "absolute",
              right: "7px",
              fontSize: "22px",
              cursor: "pointer",
              top: 0,
              color: "#000000ad",
            }}
          >
            <RxCross2 onClick={() => handleModalClose()} />
          </div>

          <RiErrorWarningLine
            style={{
              fontSize: "60px",
              color: "#ff00008a",
              display: "block",
              margin: "0 auto",
            }}
          />

          {toggleReactivate && !inactiveAccount && (
            <p className="text-center">
              {t(
                "Your account has been inactive for 180 days and has been deactivated. Would you like to reactivate it now and sign in to start using Invozio?"
              )}
            </p>)}

            {toggleReactivate && inactiveAccount && (
            <p className="text-center">
              {t(
                "Your account is inactive. Would you like to reactivate it now and sign in to start using Invozio?"
              )}
            </p>)}
        </Modal.Body>
        <div
          style={{
            width: "100%",
            display: "flex",
            justifyContent: "center",
            gap: "20px",
            marginBottom: "18px",
          }}
        >
          <Button
            style={{ width: 100 }}
            variant="secondary"
            onClick={() => handleModalClose()}
          >
            {t("No")}
          </Button>
          <Button
            disabled={isloading}
            style={{ width: 100 }}
            variant="primary"
            onClick={handleSubmit}
          >
            {<span>{t("Yes")}</span>}
          </Button>
        </div>
      </Modal>
    </>
  );
}

export default ReactivateModal;
